import type { AuthState } from '@lved/shared-core/types';

export const TheiaAuthStoragePath: string = '/services/theia-auth-storage';

export const ITheiaAuthStorageServer = Symbol('ITheiaAuthStorageServer');

/**
 * Backend store for the authenticated session. Unlike browser `localStorage`, this keeps the
 * Appwrite `sessionId` out of script-readable storage while still surviving app restarts, so the
 * user stays signed in across launches.
 */
export type ITheiaAuthStorageServer = {
    getAuthState(): Promise<AuthState>;
    saveAuthState(authState: Partial<AuthState>): Promise<void>;
    clearAuthState(): Promise<void>;
};
